import React, { Component } from "react";
import "./App.css";
import { publishedApps, upcomingApps, stats } from "./data/appData";
import translations from "./data/translations";
import NavBar from "./components/NavBar";
import Hero from "./components/Hero";
import AppsSection from "./components/AppsSection";
import UpcomingSection from "./components/UpcomingSection";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";
import SiteFooter from "./components/SiteFooter";
import FoodyPage from "./components/FoodyPage";
import FoodyPrivacyPage from "./externalPages/FoodyPrivacyPage";
import FoodyCookiePage from "./externalPages/FoodyCookiePage";
import FoodyTermsPage from "./externalPages/FoodyTermsPage";
import FoodyDeleteAccountPage from "./externalPages/FoodyDeleteAccountPage";
import FoodySupportPage from "./externalPages/FoodySupportPage";
import TrainsEscapePage from "./components/TrainsEscapePage";
import TrainsEscapeSupportPage from "./externalPages/TrainsEscapeSupportPage";
import TrainsEscapePrivacyPage from "./externalPages/TrainsEscapePrivacyPage";
import TrainsEscapeTermsPage from "./externalPages/TrainsEscapeTermsPage";

class App extends Component {
  state = {
    language: "en",
  };

  componentDidMount() {
    const locale =
      (navigator.languages && navigator.languages[0]) ||
      navigator.language ||
      "";
    if (locale.toLowerCase().startsWith("tr")) {
      this.setState({ language: "tr" });
    }
  }

  setLanguage = (language) => {
    this.setState({ language });
  };

  t = (path) => {
    const { language } = this.state;
    const keys = path.split(".");
    const resolve = (obj) => keys.reduce((acc, key) => acc && acc[key], obj);
    return resolve(translations[language]) || resolve(translations.en) || path;
  };

  render() {
    const { language } = this.state;
    const normalizedPath = window.location.pathname.replace(/\/+$/, "") || "/";
    if (normalizedPath === "/apps/foody") {
      return (
        <FoodyPage
          language={language}
          onLanguageChange={this.setLanguage}
          t={this.t}
        />
      );
    }
    if (normalizedPath === "/apps/foody/static/privacy") {
      return (
        <FoodyPrivacyPage
          language={language}
          onLanguageChange={this.setLanguage}
          t={this.t}
        />
      );
    }
    if (normalizedPath === "/apps/foody/static/cookie-policy") {
      return (
        <FoodyCookiePage
          language={language}
          onLanguageChange={this.setLanguage}
          t={this.t}
        />
      );
    }
    if (normalizedPath === "/apps/foody/static/terms-and-conditions") {
      return (
        <FoodyTermsPage
          language={language}
          onLanguageChange={this.setLanguage}
          t={this.t}
        />
      );
    }
    if (normalizedPath === "/apps/foody/static/delete-account") {
      return (
        <FoodyDeleteAccountPage
          language={language}
          onLanguageChange={this.setLanguage}
          t={this.t}
        />
      );
    }
    if (normalizedPath === "/apps/foody/static/support") {
      return (
        <FoodySupportPage
          language={language}
          onLanguageChange={this.setLanguage}
          t={this.t}
        />
      );
    }
    if (normalizedPath === "/apps/trainsescape") {
      return (
        <TrainsEscapePage
          language={language}
          onLanguageChange={this.setLanguage}
          t={this.t}
        />
      );
    }
    if (normalizedPath === "/apps/trainsescape/static/support") {
      return (
        <TrainsEscapeSupportPage
          language={language}
          onLanguageChange={this.setLanguage}
          t={this.t}
        />
      );
    }
    if (normalizedPath === "/apps/trainsescape/static/privacy") {
      return (
        <TrainsEscapePrivacyPage
          language={language}
          onLanguageChange={this.setLanguage}
          t={this.t}
        />
      );
    }
    if (normalizedPath === "/apps/trainsescape/static/terms") {
      return (
        <TrainsEscapeTermsPage
          language={language}
          onLanguageChange={this.setLanguage}
          t={this.t}
        />
      );
    }
    return (
      <div className="page" id="top">
        <NavBar
          language={language}
          onLanguageChange={this.setLanguage}
          items={[
            { href: "#apps", label: this.t("nav.apps") },
            ...(upcomingApps.length > 0
              ? [{ href: "#upcoming", label: this.t("nav.upcoming") }]
              : []),
            { href: "#about", label: this.t("nav.about") },
            { href: "#contact", label: this.t("nav.contact") },
          ]}
        />
        <main>
          <Hero
            stats={stats}
            language={language}
            showUpcoming={upcomingApps.length > 0}
            showMetrics={publishedApps.length > 2}
            t={this.t}
          />
          <AppsSection apps={publishedApps} language={language} t={this.t} />
          <UpcomingSection apps={upcomingApps} language={language} t={this.t} />
          <AboutSection t={this.t} />
          <ContactSection t={this.t} />
        </main>
        <SiteFooter t={this.t} />
      </div>
    );
  }
}

export default App;
